import dateFormat from 'dateformat';

export const showProfilePromptBtn = () => {
	/* if account bought before today, 'create your profile button should appear' */
	/* NB months are 0 - 11 */
	const createdAt = new Date(localStorage.getItem('created_person_at')),
		year = parseInt(dateFormat(createdAt, 'yyyy'), 10), month = (parseInt(dateFormat(createdAt, 'mm'), 10)), day = parseInt(dateFormat(createdAt, 'dd'), 10),
		createdAtFormatted = new Date().setFullYear(year, month - 1, day),
		cutOff = new Date().setFullYear(2018, 3, 11);
	return createdAtFormatted >= cutOff;
};

export const validateAcceptableSpecialCharacters = (value) => {
	let validation = new RegExp(/[^0-9a-zA-Z\s\’\ \‘\'\_\\\/\.\(\)\-\&\,]/);
	return value ? value.match(validation) : '';
};

export const validateName = (value) => {
	let validation = new RegExp(/[^A-Za-z\-\ \-\']/);
	return value ? value.match(validation) : '';
};

export const validateEmailAddress = (value) => {
	let errors, validation = new RegExp(/.+@.+\..+/);
	errors = !value.match(validation);

	return errors;
};

export const validateURL = (value) => {
	let errors, validation = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\.\_\~\:\/\?\#[\]@!\$\&\'\(\)\*\+\,\;\=\.]+$/gm);
	errors = !value.match(validation);

	return errors;
};


export const siteOfOriginHelper = () => {
	return localStorage.getItem('site_of_origin') === 'us' ? 'us' : 'gb';
}

export const countryAbbrToCode = abbreviation => {
	switch( abbreviation ){
		case 'gb':
			return 77;
        case 'us':
			return 233;
		default:
			return null;
	}
};



// WEBPACK FOOTER //
// src/client/helpers/genericHelpers.js